import { toast } from 'sonner'

import { Button } from '@/components/ui/button'
import { CopyButton } from '@/components/ui/CopyButton'
import { Demo, DsSection } from '../primitives'

const TOASTS: { call: string; trigger: string; fire: () => void }[] = [
  { call: 'toast()', trigger: 'Default', fire: () => toast('Draft saved') },
  {
    call: 'toast.success()',
    trigger: 'Success',
    fire: () => toast.success('Link copied! Anyone with the link can view your quotes'),
  },
  {
    call: 'toast.error()',
    trigger: 'Error',
    fire: () => toast.error('Could not save. Please try again.'),
  },
  {
    call: 'toast.warning()',
    trigger: 'Warning',
    fire: () => toast.warning('These quotes expire in 3 days'),
  },
  {
    call: 'toast.info()',
    trigger: 'Info',
    fire: () => toast.info("We'll email you when your quotes are ready"),
  },
  {
    call: 'toast.loading()',
    trigger: 'Loading',
    fire: () => toast.loading('Generating your certificate…'),
  },
  { call: 'toast.dismiss()', trigger: 'Dismiss all', fire: () => toast.dismiss() },
]

function ToastDemo({ call, trigger, fire }: { call: string; trigger: string; fire: () => void }) {
  return (
    <div className="flex flex-col items-start gap-2">
      <Button variant="outline" size="sm" onClick={fire}>
        {trigger}
      </Button>
      <div className="text-ink-400 flex items-center gap-1 font-mono text-[10px]">
        <span>{call}</span>
        <CopyButton
          value={call}
          className="text-ink-400 hover:text-ink size-4 bg-transparent hover:bg-transparent"
        />
      </div>
    </div>
  )
}

export function ToastSection() {
  return (
    <DsSection id="toast" title="Toast">
      <Demo label="Types — each fires a real toast, top center" className="flex flex-wrap items-start gap-6">
        {TOASTS.map((t) => (
          <ToastDemo key={t.call} {...t} />
        ))}
      </Demo>
    </DsSection>
  )
}
